import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { OrderTemplate } from "../models/OrderTemplate";

export class OrderService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/order-templates`;
  }

  async getTemplate(): Promise<Response<OrderTemplate | void>> {
    const response = await axios.get(this.baseUrl);
    return response.data;
  }

  async updateTemplate(
    id: string,
    orderTemplate: OrderTemplate
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, orderTemplate);
    return response.data;
  }

  async checkOrderByServiceTemplate(
    serviceTemplateId: string
  ): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/check-by-service-template/${serviceTemplateId}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getOrderTempSchema(): Promise<Response<GroupFullSchema>> {
    const serviceURL = `${this.baseUrl}/schema`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
